import { action } from 'satcheljs/lib/legacy';
export default action('setPreviewLoaded')(function setPreviewLoaded(attachment, newValue) {
    attachment.previewLoaded = newValue;
});
//# sourceMappingURL=setPreviewLoaded.js.map